import React from 'react';
import { Typography, Image, Button } from 'tfc-components';

import line from 'assets/images/decor-title-white.png';
import Section from 'components/organisms/Section';

const Collaborate: React.FC = () => (
  <Section className="p-home_collaborate">
    <Typography.Heading type="h2" extendClasses="f-36x48 p-home_collaborate_title" fontweight="600">
      What’s next at EVOL LABS?
    </Typography.Heading>
    <Image extendClasses="p-home_collaborate_line" imgSrc={line} alt="EVOL Labs" ratio={51 / 3} />
    <Typography.Text type="p" extendClasses="f-20x24 p-home_collaborate_text">
      We’re constantly exploring new AI-native opportunities
    </Typography.Text>
    <Typography.Text type="p" extendClasses="f-18x24 p-home_collaborate_text" fontweight="600">
      Have a challenge we can help with? Let’s talk.
    </Typography.Text>
    <Button extendClasses="fButton p-product_collaborate_button">
      <Typography.Text>Contact us </Typography.Text>
    </Button>
  </Section>
);

export default Collaborate;
